export default __webpack_public_path__ + "media/Objective/Objective-Bold-Italic-80ddd1c3ec880860adeedbc9be97dedf.woff2";